// 报销申请工单
<template>
  <div class="woStyle">
      <div class="backBtn">
            <el-button type="primary" size=mini @click="backWorkOrder()" v-if="isSign">返回</el-button>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  label-width="125px" class="demo-ruleForm" label-position="right">
        <h3>费用报销申请</h3>
        <div>
            <el-form-item label="报销人" :class="className">
                <el-input v-model="userName" disabled></el-input>
            </el-form-item>
            <el-form-item label="部门" :class="className">
                <el-input v-model="departmentName" disabled></el-input>
            </el-form-item>
            <el-form-item label="费用类别" prop="type" :class="className" >
                <el-select v-model="ruleForm.type" placeholder="请选择费用类别" style="width:100%;">
                    <el-option 
                    v-for="(item,index) in costTypeOption" 
                    :key="index" 
                    :label="item.label" 
                    :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="金额" prop="money" :class="className">
                <el-input v-model="ruleForm.money"></el-input>
            </el-form-item>
            <el-form-item label="具体事项" prop="test" :class="className">
                <el-input v-model="ruleForm.test" type="textarea" autosize></el-input>
            </el-form-item>
        </div>

        <!-- 按钮区域 -->
        <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="btnState">确认</el-button>
            <el-button @click="resetForm('ruleForm')" :loading="btnState">重置</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from '../../libs/utils.js'
import api from '../../api'
export default {
props:{
    reviseFormData:{// 通过修改窗口传来的现有表单信息
        type:Object,
        default:() => {
            return {}
        }
    },
    className:{
        type:String,
        default:"formItems"
    }
},
data(){
    let userId = utils.sessionGetStore('user_id')
    let userName = utils.sessionGetStore('user_name')
    let departId = utils.sessionGetStore('department')// 部门id
    let departName = utils.sessionGetStore('departmentName')// 部门名称
    return {
        btnState:false,
        userId:userId,
        userName:userName,
        departmentName:departName,//部门名字
        ruleForm:{
            user_id:userId,//报销人id
            department:departId,//部门id
            type:'',//费用类别
            test:'',//具体事项
            money:'',// 金额
        },
        rules:{
            type:[
                {required: true, message:'请选择费用类型', trigger:'change'}
            ],
            test:[
                {required: true, message:'请填写具体事项', trigger:'blur'}
            ],
            money:[
                {required: true, message:'请填写金额', trigger:'blur'}
            ],
        },
        isSign: true,// 是否是新建
        costTypeOption:[],// 费用类别选项
    }
},
watch:{
    'ruleForm':{
        handler:function(val){
            if(this.isSign){
                utils.sessionSetStore('reimburFormData',val)
            }
        },
        deep:true
    }
},
methods:{
backWorkOrder(){
    window.history.go(0)
},
// 重置
resetForm(formName) {
    this.$refs[formName].resetFields();
},
// 工单提交
submitForm(formName) {
    this.$refs[formName].validate((valid) => {
        if (valid) {
            let paramObj = this.ruleForm

            // 更新按钮状态
            this.btnState = true

            if(!this.isSign){
                // 修改信息


                api.reviseReimbursement(paramObj)
                .then(res => {
                    // 更新按钮状态
                    this.btnState = false
                    // console.log('返回值',res)
                    utils.notificationInfo("提示","修改信息成功","success")
                    // 重置表单
                    this.$refs[formName].resetFields();
                    setTimeout(function(){
                        window.location.reload()
                    },500)
                })
                .catch((err)=>{
                    // 更新按钮状态
                    this.btnState = false
                    console.log(err)
                    utils.notificationInfo("提示","修改信息失败","error")
                })
            }else{
                // 新建报销申请
                
                api.newReimbursementApply(paramObj)
                    .then(res => {
                        // 更新按钮状态
                        this.btnState = false
                        // console.log(res)
                        utils.notificationInfo("提示","申请报销工单创建成功","success")

                        // 传给父组件
                        this.$emit('completeView','true')

                        // 清除缓存的表单信息
                        utils.sessionRemoveStore('invoiceFormData') 
                    })
                    .catch(error => {
                        // 更新按钮状态
                        this.btnState = false
                        utils.notificationInfo('提示','提交失败','warning')
                        return Promise.reject(error);
                    });
            }

            

        } else {
            utils.notificationInfo('提示','提交失败','warning')
        return false;
        }
    });
},

},

mounted(){
    this.isSign = Object.keys(this.reviseFormData).length == 0 ? true : false

    // 判断是否是新建，是----获取本地已填表单
    if(this.isSign){
        let formData = JSON.parse(utils.sessionGetStore('reimburFormData'))
        if(formData){
            Object.keys(formData).forEach(item => {
                this.ruleForm[item] = formData[item]
            })

        }
    }else {
        // 修改窗口调用了该组件，将现有内容赋值给表单
        Object.keys(this.ruleForm).forEach(item => {
            this.ruleForm[item] = this.reviseFormData[item]
        })
        this.ruleForm.id = this.reviseFormData.id// 工单id
        this.userName = this.reviseFormData.user_name
        switch(this.reviseFormData.department){
            case '1':
                this.departmentName = '人事部'
                break;
            case '2':
                this.departmentName = '财务部'
                break;
            case '3':
                this.departmentName = '市场部'
                break;
            case '4':
                this.departmentName = '运营部'
                break;
            case '5':
                this.departmentName = '招商部'
                break;
            case '6':
                this.departmentName = '总经办'
                break;
            case '7':
                this.departmentName = '技术部'
                break;
        }
    }

    switch(this.departmentName){
        case '人事部':
            this.costTypeOption = [
                {
                    label: '办公费',
                    value: '办公费'
                },
                {
                    label: '招聘费',
                    value: '招聘费'
                },
                {
                    label: '员工福利',
                    value: '员工福利'
                },
                {
                    label: '管理层福利',
                    value: '管理层福利'
                },
            ]
            break;
        case '财务部':
            this.costTypeOption = [
                {
                    label: '办公费',
                    value: '办公费'
                },
            ]
            break;
        case '市场部':
            this.costTypeOption = [
                {
                    label: '电话费',
                    value: '电话费'
                },
                {
                    label: '快递费',
                    value: '快递费'
                },
                {
                    label: '交通费',
                    value: '交通费'
                },
            ]
            break;
        case '运营部':
            this.costTypeOption = [
                {
                    label: '安托',
                    value: '安托'
                },
                {
                    label: '小捕快',
                    value: '小捕快'
                },
                {
                    label: '激励费',
                    value: '激励费'
                },
                {
                    label: '业务招待费',
                    value: '业务招待费'
                },
                {
                    label: '其他',
                    value: '其他'
                },
            ]
            break;
        case '招商部':
            this.costTypeOption = [
                {
                    label: '差旅费',
                    value: '差旅费'
                },
                {
                    label: '福利费',
                    value: '福利费'
                },
                {
                    label: '激励费',
                    value: '激励费'
                },
                {
                    label: '业务招待费',
                    value: '业务招待费'
                },
            ]
            break;
        case '总经办':
            this.costTypeOption = [
                {
                    label: '差旅费',
                    value: '差旅费'
                },
                {
                    label: '业务招待费',
                    value: '业务招待费'
                },
                {
                    label: '管理层聚餐',
                    value: '管理层聚餐'
                },
                {
                    label: '部门聚餐',
                    value: '部门聚餐'
                },
            ]
            break;
        case '技术部':
            this.costTypeOption = [
                {
                    label: 'VPS服务器',
                    value: 'VPS服务器'
                },
                {
                    label: '阿里云',
                    value: '阿里云'
                },
                {
                    label: '订单侠',
                    value: '订单侠'
                },
                {
                    label: '淘宝账号费用',
                    value: '淘宝账号费用'
                },
                {
                    label: '万邦API',
                    value: '万邦API'
                },{
                    label: '其他',
                    value: '其他'
                },
            ]
            break;
    }
},

}
</script>

<style lang="scss" scoped>
.demo-ruleForm{
    width: 70%;
    margin:0 auto;

    .formItems{
        width: 70%;
    }
    .formItems2{
        width: 100%;
        margin-left:-20px;
    }
}
.el-form-item {
    ::v-deep .el-form-item__label{
        font-size: 12px;
    }
}
</style>